<template>
  <div 
    class="card" 
    @mouseenter="hoverId = item.codigo"
    @mouseleave="hoverId = null"
    :style="{width: '200px'}"
  >
    <div
      ref="current-speaker"
      class="speaker-img"
      :style="{
        '--zoom-size': `${settings.layout.zoom || '125'}%`,
        backgroundImage: `url('${item.url_avatar}')`,
      }"    
    >
      <div 
        class="bg-gradient"
        :style="`background: linear-gradient(180deg, transparent, transparent 0%, ${settings.layout.color1 || '#0A9AED'})`"
      >
      </div>

      <div 
        class="overlapping px-4 py-1 mb-2" 
        :style="{
          height: item.linkedin && (settings.layout.linkedinIcon || hoverId === item.codigo)  ? '100px': '70px',
        }"
      >
        <span 
          class="titleCard" 
          :style="{
            color: settings.layout['text-color1'] || '#FFF', 
            fontSize: item.nome.length > 15 ? '15px': '20px'
          }"
        >
        {{item.nome}}
        </span>

        <v-tooltip bottom max-width="220" :disabled="!infoTooltip" :color="settings.layout['tooltip-color']">
          <template v-slot:activator="{ on }">
            <span 
              v-on="on"
              ref="info-speaker"
              class="subtitleCard" 
              :style="{
                color: settings.layout['text-color2'] || '#FFF'
              }"
            >
              {{ getSpeakerInfo }}
            </span>
          </template>
          <div :style="{'font-size': '0.8rem'}">
            <span class="d-block pb-2">
              <b :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF', 'font-weight': '900'}">
                {{ item.cargo }}
              </b>
            </span>

            <span class="d-block" :style="{color: settings.layout['tooltip-text-color'] || '#FFFFFF'}">
              {{ item.empresa }}
            </span>
          </div>
        </v-tooltip>

        <div 
          v-if="item.linkedin && (settings.layout.linkedinIcon || hoverId === item.codigo)"
          :class="['linkedin text-center pt-2']"
        >
          <v-btn 
            fab 
            color="transparent" 
            class="elevation-0" 
            x-small 
            @click.stop="$emit('onClickLinkedin', item)"
          >
            <i 
              class="fa-brands fa-linkedin" 
              :style="{
                'font-size': '1.5rem',
                'color': settings.layout['color2'] || '#FFF',
              }"
            >
            </i>
          </v-btn>
        </div>
      </div> 
    </div>

  </div>
</template>

<script>

export default {
  props: ["item", "settings"],
  computed: {
    getBoxShadow () {
      const shadow = this.settings.layout.shadow
      const distance = this.settings.layout.distance
      if (shadow) return `${distance}px ${distance}px 0 1px ${shadow}`
      else return 'none'
    },

    getSpeakerInfo () {
      if (this.settings.layout.companyPosition) return `${this.item.cargo} - ${this.item.empresa}`
      else return this.item.empresa
    }
  },

  data: () => ({
    hoverId: null,
    infoTooltip: false
  }),

  watch: {
    hoverId (id) {
      const currentSpeaker = this.$refs['current-speaker']
      if (id === this.item.codigo) {
        currentSpeaker.style.backgroundSize = `auto var(--zoom-size) !important`
        const infoSpeaker = this.$refs['info-speaker']
        const isInfoSpeakerEllipsed = infoSpeaker.scrollHeight > infoSpeaker.clientHeight
        this.infoTooltip = isInfoSpeakerEllipsed
      } else {
        currentSpeaker.style.backgroundSize = `auto 100%`
        this.infoTooltip = false
      }
    }
  }
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 200px;
  max-width: 200px;
  transition: all 1s;
  padding-bottom: 12px;
}

.card:hover {
  cursor: pointer;
  transform: translateY(-8px);
}

.speaker-img {
  position: relative;
  transition: all 0.5s;
  width: 200px;
  height: 320px;
  background-position: center;
  background-size: auto 100%;
}

.speaker-img:hover {
  cursor: pointer;
  background-size: auto var(--zoom-size) !important;
}

span {
  display: block;
}

.bg-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 65%;
}

.overlapping {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: start !important;
  transition: all 0.5s ease;
  width: 100%;
}

.titleCard {
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0px;
  line-height: 30px;
  text-align: left;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  max-height: 100%;  
}

.subtitleCard {
  font-size: 13.5px;
  font-style: normal;
  font-weight: 500;
  text-align: left;
  line-height: 18px;
  overflow: hidden; 
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  max-height: 100%;
  color: #666D80;
  text-transform: uppercase;
}

.linkedin {
  top: 0px;
  right: 14px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: start;
  justify-content: start;
}
</style>
